module.exports = __webpack_public_path__ + "static/media/service-furniture-desktop.d4cb68f7.png";